import { Alert } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'

const MSG = defineMessages({
  title: {
    id: 'AssumablesDifficultyNotice.title',
    defaultMessage: 'Assumables can be difficult to get'
  },
  body: {
    id: 'AssumablesDifficultyNotice.body',
    defaultMessage:
      'Assumable mortgages can be complicated and are not always the right choice. Make sure you talk through all the details with your lending advisor.'
  }
})

export const AssumablesDifficultyNotice = ({ ...restProps }) => {
  const intl = useIntl()

  return (
    <Alert title={intl.formatMessage(MSG.title)} {...restProps} status='warning'>
      {intl.formatMessage(MSG.body)}
    </Alert>
  )
}
